import { CountryCode } from "../types/common";

/**
 * Google Tag Manager container per country (customer, partner, websites).
 * One container per country, used by every environment (staging and test
 * report into the production containers; the `environment` dataLayer event
 * tells them apart). Pure data: Next.js and Node can import it.
 */
export const GTM_IDS: Record<CountryCode, string> = {
  [CountryCode.SE]: "GTM-PDQ5MPJ",
  [CountryCode.FI]: "GTM-56JQDSP",
};

/** Container for a country; `""` (no container) for a country outside the table. */
export const getGtmId = (country: CountryCode): string =>
  GTM_IDS[country] ?? "";
